import { NotificationMessages } from '../types';

export const notificationZHCN: NotificationMessages = {
    'app.notification.title': '通知中心',
    "app.notification.generate_file": "我们正在生成您的文件。文件准备好后，您将收到下载通知。",
    'app.notification.download_program': '下载程序详情',
};
